var map = {
	"./ninelines_en.png": "jSdw",
	"./ninelines_esp.png": "6gUN",
	"./ninelines_th.png": "0zQB"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xFa8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas ^\.\/ninelines_.*\.png$
// module id = xFa8
// module chunks = 1